export default class AppConfirmed {
    constructor () {
        this.init();
    }

    init () {
        $('body').on('click', 'a[data-toggle=confirmed]', function (e) {
            e.preventDefault();

            let $link = $(this);
            let type = $link.attr('data-confirmation-type');
            let ajax = $link.attr('data-confirmation-ajax') === '1';
            let callbackName = $link.attr('data-confirmation-callback') || 'default';
            let alert = new Promise(function (resolve) {
                resolve(false);
            });
            let callbacks = {
                'default': function () {
                    window.location.reload();
                },
                'delete-media': function () {
                    $link.parents('.image-item').parent().remove();
                },
                'deliver-media': function () {
                    $link.replaceWith('<i class="fas text-success fa-paint-brush"></i>');
                },
            };
            let callback = callbacks[callbackName] || callbacks.default;

            switch (type) {
            case 'delete':
                alert = swal({
                    title: window.trans.alert.delete.title,
                    text: window.trans.alert.delete.text,
                    icon: 'error',
                    buttons: [
                        window.trans.alert.cancel,
                        window.trans.alert.delete.button,
                    ],
                    dangerMode: true,
                });
                break;
            case 'deliver':
                alert = swal({
                    title: window.trans.alert.deliver.title,
                    text: window.trans.alert.deliver.text,
                    icon: 'warning',
                    buttons: [
                        window.trans.alert.cancel,
                        window.trans.alert.deliver.button,
                    ],
                    dangerMode: false,
                });
                break;
            case 'cleanup':
                alert = swal({
                    title: window.trans.alert.cleanup.title,
                    text: window.trans.alert.cleanup.text,
                    icon: 'error',
                    buttons: [
                        window.trans.alert.cancel,
                        window.trans.alert.cleanup.button,
                    ],
                    dangerMode: true,
                });
                break;
            }

            alert.then((confirmed) => {
                if (confirmed) {
                    if (!ajax) {
                        window.location = $link.attr('href');
                    } else {
                        $.ajax({
                            url: $link.attr('href'),
                        }).done(function () {
                            callback();
                        });
                    }
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/confirmed.js